import ReactDOM from "react-dom";

export interface PortalProps {
  children: any;
  parentSelector?: string;
}
const Portal = (props: PortalProps) => {
  return ReactDOM.createPortal(
    props.children,
    (props.parentSelector ? document.querySelector(props.parentSelector) : null) ?? document.body
  );
};

export default Portal;
